(function() {
	angular.module('ShargoApp')
		.service('FooterService', function($http, Configuration) {
			var svc = {};
			svc.addNewsletter = function(data) {
				var params = {
					email: data
				};
				return $http.post(Configuration.apiUrl + '/newsletter', params);
			};

			return svc;
		})
		.controller('FooterController', function ($scope, $timeout, FooterService, Configuration) {
			$scope.newsletter = "";
			$scope.newsletterRadioButton = "";
			$scope.errorNewsletter = $scope.errorTerms = $scope.terms = $scope.send = false;
			$scope.newsletterRadioButton = Configuration.siteDomain + "/img/svg/radio-button-empty.svg";

			function actualizeNewsletter() {
				$scope.errorNewsletter = $scope.errorTerms = false;
				$scope.newsletterRadioButton= $scope.newsletterRadioButton=== Configuration.siteDomain + "/img/svg/radio-button-empty.svg" ? Configuration.siteDomain + "/img/svg/radio-button-fill.svg" : Configuration.siteDomain + "/img/svg/radio-button-empty.svg";
				$scope.terms = !$scope.terms;
			}

			function confirmNewsletter() {
				if (!$scope.terms) {
					$scope.errorTerms = true;
				}
				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				if (!$scope.newsletter || !re.test($scope.newsletter)) {
					$scope.errorNewsletter = true;
				}
				if (!$scope.errorNewsletter && !$scope.errorTerms) {
					FooterService.addNewsletter($scope.newsletter)
						.then(function (response) {
							$scope.send = true;
							$timeout(function(){
								$scope.send = false;
							}, 3000);
						})
						.catch(function (data) {
							console.log("ERROR IN FOOTER NEWSLETTER: ", data);
							$scope.errorNewsletter = true;
						});
				}
			}
			
			$scope.confirmNewsletter = confirmNewsletter;
			$scope.actualizeNewsletter = actualizeNewsletter;
		});
})();